export default __webpack_public_path__ + "static/undraw_confirmation_2uy0-3d421fd0f480dd9815b48db1bcb95ac8.svg";